import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  type DiscoveryDataEnrichmentLink,
  readDiscoveryDataEnrichmentLink,
} from './discoveryDataEnrichmentLink';

/**
 * Reads the hand-off of a label source link and drops it from the history
 * entry, so a page reload or a later navigation starts clean. A hand-off can
 * also arrive while the page stays mounted, when a link on the page points to
 * another of its tabs.
 */
export const useDiscoveryDataEnrichmentLink =
  (): DiscoveryDataEnrichmentLink | null => {
    const { pathname, state } = useLocation();
    const navigate = useNavigate();
    // a history entry keeps its state identity, so the same hand-off is read
    // only once and a new one is told apart by its identity
    const handOff = useMemo(
      () => readDiscoveryDataEnrichmentLink(state),
      [state],
    );
    const [link, setLink] = useState(handOff);

    useEffect(() => {
      if (handOff === null) {
        return;
      }

      setLink(handOff);
      navigate(pathname, { replace: true, state: null });
    }, [handOff, pathname]);

    return link;
  };
